<div class="app-base-structure app-folder-structure" *transloco="let t">
  <mat-label class="app-base-structure__heading">{{
    t("step3.eh-mydocuments-step3-export-folder-structure-title")
  }}</mat-label>
  <div class="app-base-structure__list">
    <div class="app-base-structure__selection-container">
      <ng-container
        [ngTemplateOutlet]="dropdownBox"
        [ngTemplateOutletContext]="{ index: 0 }"
      ></ng-container>
      <ng-container
        [ngTemplateOutlet]="dropdownBox"
        [ngTemplateOutletContext]="{ index: 1 }"
      ></ng-container>
      <ng-container
        [ngTemplateOutlet]="dropdownBox"
        [ngTemplateOutletContext]="{ index: 2 }"
      ></ng-container>
      <ng-container
        [ngTemplateOutlet]="dropdownBox"
        [ngTemplateOutletContext]="{ index: 3 }"
      ></ng-container>
      <ng-container
        [ngTemplateOutlet]="dropdownBox"
        [ngTemplateOutletContext]="{ index: 4 }"
      ></ng-container>
    </div>
    <ng-container [ngTemplateOutlet]="exampleBox"></ng-container>
  </div>
  <button
    mat-button
    [disabled]="!didDropdownDefaultChange"
    (click)="resetFolderSettings()"
  >
    <div class="app-base-structure__reset-container">
      <mat-icon
        class="app-base-structure__reset-button-icon"
        svgIcon="eh-refresh"
      ></mat-icon>
      <mat-label class="app-base-structure__reset-button">
        {{ t("step3.eh-mydocuments-step3-export-reset-folder-structure") }}
      </mat-label>
    </div>
  </button>
  <div class="app-base-structure__separator"></div>
</div>

<ng-template #dropdownBox let-index="index">
  <div class="app-base-structure__dropdown-container" *transloco="let t">
    <mat-label class="app-base-structure__dropdown-label">{{
      t("step3.eh-mydocuments-step3-export-level") + (index + 1)
    }}</mat-label>
    <div
      #dropdownFake
      class="app-base-structure__dropdown-fake"
      [ngClass]="
        !isDropdownIconOpen[index]
          ? 'app-base-structure__dropdown-fake-open'
          : ''
      "
    >
      <mat-select
        #folderDropdown
        [panelWidth]="dropdownWidth + 'px'"
        class="app-base-structure__dropdown"
        (openedChange)="onOpenedDropdown(index)"
        (closed)="onClosedDropdown(index)"
        [placeholder]="t('step3.eh-mydocuments-step3-dropdown-label')"
        [value]="preselectedInDropdown[index]"
      >
        <mat-option
          class="app-base-structure__placeholder"
          [ngClass]="
            preselectedInDropdown[index]
              ? ''
              : 'app-base-structure__placeholder-selected'
          "
          (onSelectionChange)="onClearDropdown(index)"
          >{{ t("step3.eh-mydocuments-step3-dropdown-label") }}</mat-option
        >
        @for (setting of folderSettings |
        isNotIncluded:alreadyIncludedShortNames:preselectedInDropdown[index];
        track setting) {
        <mat-option
          [value]="setting.shortName"
          (onSelectionChange)="onSetFolderSetting($event, setting, index)"
          >{{ settingsPartTexts[setting.shortName] }}</mat-option
        >
        }
      </mat-select>
      <mat-icon
        class="app-base-structure__close-icon"
        *ngIf="preselectedInDropdown[index]"
        (click)="onClearDropdown(index)"
        >close</mat-icon
      >
      <mat-icon
        class="app-base-structure__dropdown-icon app-base-structure__dropdown-open"
        *ngIf="isDropdownIconOpen[index]"
        (click)="onIconClick(index)"
        >keyboard_arrow_down</mat-icon
      >
      <mat-icon
        class="app-base-structure__dropdown-icon app-base-structure__dropdown-close"
        *ngIf="!isDropdownIconOpen[index]"
        (click)="onIconClick(index)"
        >keyboard_arrow_up</mat-icon
      >
    </div>
  </div>
</ng-template>

<ng-template #exampleBox>
  <div class="app-base-structure__example-container" *transloco="let t">
    <mat-label
      class="app-base-structure__expample-text app-base-structure__expample-title"
      >{{
        t("step3.eh-mydocuments-step3-export-folder-example-title")
      }}</mat-label
    >
    <mat-label class="app-base-structure__expample-text">{{
      folderExampleText
    }}</mat-label>
  </div>
</ng-template>
